import {Component, HostListener} from '@angular/core';
import {Http} from '@angular/http';
import {ToasterService} from 'angular2-toastr';
import {Cam} from './cam';
import {CamService} from './cam.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    providers: [CamService, ToasterService],
})
export class AppComponent {
    title = 'Webcam Game';
    cams: Cam[];
    editingCam = null;
    difficulty = 0;
    actionbarVisible = false;

    constructor(private http: Http, private camService: CamService, private toasterService: ToasterService) {
        let that = this;
        camService.getCams().then(function (cams: Cam[]) {
            that.cams = cams;

            that.cams.map(function (cam: Cam) {
                camService.updateCam(cam);
            });
        });

        toasterService.success('Welcome', 'Welcome to the Game!', true, 10000);
    }

    @HostListener('document:keydown.Alt.S', ['$event'])
    handleKeyToggleSettings(event: KeyboardEvent) {
        this.toggleActionbar();
    }

    @HostListener('document:keydown.Escape', ['$event'])
    handleKeyEscape(event: KeyboardEvent) {
        this.actionbarVisible = false;
        this.editingCam = null;
    }

    foundCam(cam: Cam): void {
        cam.isFound = !cam.isFound;
    }

    editCam(cam: Cam): boolean {
        console.log('Editing', cam);
        this.editingCam = cam;

        // Don't show contextmenu
        return false;
    }

    stopEditingCam(cam: Cam): void {
        this.editingCam = null;

        this.updateCam(cam);
    }

    removeCam(camToRemove: Cam): void {
        this.cams = this.cams.filter(item => item !== camToRemove);
    }

    removeAllCams(): void {
        this.cams = [];
    }

    storeCams(): void {
        this.camService.storeCams(this.cams).then(function () {
            alert('Successfully stored cams');
        });
    }

    addCam(): void {
        const names: string[] = ['Jan', 'Piet', 'Truus', 'Kees', 'Henk', 'Mohammed', 'Abdulah', 'Anna'];
        const name: string = names[Math.floor(Math.random() * names.length)];

        let cam: Cam;
        if (this.cams.length > 0) {
            cam = Object.assign({}, this.cams[0]);
            cam.name = name;
        } else {
            cam = new Cam('10.0.0.1', name);
        }

        this.cams.push(cam);
    }

    updateDifficulty(difficulty: number): void {
        this.difficulty = difficulty;

        for (const cam of this.cams) {
            cam.quality = 100 - this.difficulty;
            console.log(difficulty);
            console.log(cam.quality);
            this.camService.updateCam(cam);
        }
    }

    updateWidth(width: string): void {
        for (const cam of this.cams) {
            cam.width = width;
            this.camService.updateCam(cam);
        }
    }

    updateCam(cam: Cam) {
        this.camService.updateCam(cam);
    }

    toggleActionbar() {
        this.actionbarVisible = !this.actionbarVisible;
    }
}


// WEBPACK FOOTER //
// /data/workspace/projects/camhunter/src/app/app.component.ts